export default "__VITE_ASSET__DnqAX_0m__"